import React from "react";
import { Target, Eye } from "lucide-react";

const CARDS = [
  {
    icon: Target,
    title: "Our Mission",
    text: "Our mission is to empower individuals to live healthier, happier lives by providing comprehensive and compassionate home healthcare services that are tailored to their unique needs and preferences. We believe in delivering exceptional clinical care and personalized attention to patients and their families, fostering a supportive and healing environment that promotes well-being, independence, and a deeper sense of security.",
  },
  {
    icon: Eye,
    title: "Our Vision",
    text: "To be the leading provider of personalized, high-quality healthcare services in India, known for our unwavering commitment to compassionate care and exceptional patient experiences. We envision a future where advanced technology and human connection work together seamlessly, setting a new global standard of excellence and becoming the ultimate, trusted partner for families seeking comprehensive and dependable medical support throughout their lifetime.",
  },
];

const MissionVision = () => {
  return (
    <section className="py-16 md:py-24 px-5 md:px-8">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-7">
        {CARDS.map((c, i) => (
          <div
            key={c.title}
            className="relative bg-white rounded-[26px] border border-[#DEE6EE] shadow-[0_10px_35px_rgba(0,0,0,0.05)] px-7 md:px-10 pt-16 pb-10 text-center hover:shadow-[0_20px_50px_rgba(0,0,0,0.1)] transition-shadow fade-up"
            style={{ transitionDelay: `${i * 90}ms` }}
          >
            <span
              className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center justify-center w-16 h-16 rounded-full shadow-[0_12px_30px_rgba(21,154,144,0.4)]"
              style={{ background: "linear-gradient(145deg, #17A79B 0%, #0E7A72 100%)" }}
            >
              <c.icon size={28} className="text-white" strokeWidth={2} />
            </span>
            <h3 className="font-heading font-extrabold text-[#159A90] text-[26px] md:text-[30px]">
              {c.title}
            </h3>
            <p className="text-[#57616e] text-[15.5px] md:text-[16px] leading-relaxed mt-5">
              {c.text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MissionVision;
